import CommissionService from '@/services/CommissionService';

// state
const localState = {
  amountCommissions: {},
};

// getters
const localGetters = {};

const mutations = {
  setCommission(state, payload) {
    state.amountCommissions = payload;
  },
  removeCommission(state, payload) {
    state.amountCommissions = state.amountCommissions.filter(item => item.staffId !== payload.staffId);
  },
}
// actions
const actions = {
  async payCommission({ state, commit }, obj) {
    const { result, commission, errors } = await CommissionService.payCommission(obj);
    state.errors = errors;
    return result;
  },
  async getCommission({ state, commit }) {
    const result = await CommissionService.getList();
    if(result && result.commissions) {
      commit('setCommission', result.commissions);
    }
  },
};

export default {
  state: localState,
  getters: localGetters,
  actions,
  mutations,
};
